export const text = {
  edit: "Edit Product",
  product: "Product",
};
